import { MessageContentUpdate } from '../models/message-content.model';

export const messageContentUpdateKeys: (keyof MessageContentUpdate)[] = [
    'structure',
    'deeplink',
    'deeplink_dataset_field_id',
    'dataset_id',
    'dataset_filters_id',
    'ios_notification_category',
    'is_label_matching_enabled',
    'cms_type',
];
